import React from "react";

class Field extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { field, validation } = this.props;

        return (
            <div class={`formContainer ${field.id == "color" ? "colorPicker" : ""}`}>
                <label>{field.label} {field.required && <sup>*</sup>}</label>
                {this.props.view === "form" && !field.displayOnly && (
                    <React.Fragment>
                        {field.component? field.component :
                            <React.Fragment>
                                <input
                                    id={field.id}
                                    class={field.fieldClass}
                                    type="text"
                                    placeholder={field.placeholder}
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                                {Object.keys(validation).length > 0 && field.id === 'groupEmail' && validation[field.id] && field.value &&
                                    <React.Fragment>
                                        <span class="errorMessage"> <i class="material-icons-outlined mr10">info</i>Invalid Email Address</span>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                      }
                        {/* {!field.component && (
                            <React.Fragment>
                                <input
                                    id={field.id}
                                    class={field.fieldClass}
                                    type="text"
                                    placeholder={field.placeholder}
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                                {Object.keys(validation).length > 0 &&  field.id === 'groupEmail' && validation[field.id] && field.value &&
                                    <React.Fragment>
                                        <span class="errorMessage"> <i class="material-icons-outlined mr10">info</i>Invalid Email Address</span>
                                    </React.Fragment>
                                }
                            </React.Fragment>


                        )} */}
                    </React.Fragment>
                )}
                {(this.props.view === "view" || field.displayOnly) && (
                    <span>{field.defaultValue ? field.defaultValue : field.placeholder}</span>
                )}
            </div>
        );
    }
}

export default Field;